<template>
  <div class="system-user-review-detail">
    <Row :style="{marginBottom: '10px'}">
      <div :style="{float: 'left'}">
        <Button size="small" icon="ios-arrow-back" @click="$router.push({name: 'systemUserReview', query: { page: $route.query.lastPage }})">返回列表</Button>
      </div>
    </Row>
    <Card shadow>
      <div class="content">
        <div class="main">
          <div>
            <Row style="margin-bottom: 10px" :gutter="16">
              <Col :xs="24" :sm="24" :md="24" :lg="19">
                <Row class="title">
                  <h4 :style="{float: 'left'}">系统用户复核详情</h4>
                </Row>
                <Alert v-if="infoError" type="warning" show-icon>获取数据失败</Alert>
                <div class="info-property" v-else>
                  <dl>
                    <dt>申请人</dt>
                    <dd v-if="info.ops_user_dict">{{ info.ops_user_dict.name ? info.ops_user_dict.name : info.ops_user_dict.username }}</dd>
                  </dl>
                  <dl>
                    <dt>标题</dt>
                    <dd>{{ info.title }}</dd>
                  </dl>
                  <dl>
                    <dt>备注</dt>
                    <dd class="system-user-review-detail-describe"><span v-html="info.remark"></span></dd>
                  </dl>
                  <dl>
                    <dt>附件</dt>
                    <dd>
                      <div v-for="(item, index) in info.ops_file" :key="index" @click="download(item.id, item.name)">
                        <a target="_blank">{{ item.name }} (点击下载)</a>   &nbsp;
                      </div>
                    </dd>
                  </dl>
                  <dl v-if="info.created_at">
                    <dt>申请时间</dt><dd>{{ moment(info.created_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                  </dl>
                  <dl style="margin-top: 15px">
                    <dt>操作</dt>
                    <dd>
                        <p slot="title">处理阶段</p>
                        <Steps :current="current">
                          <Step title="运维">
                            <template slot="content">
                              <div v-if="Object.keys(info.ops_user_dict).length !== 0">{{ info.ops_user_dict.name }}</div>
                              <div v-if="Object.keys(info.ops_file).length !== 0">
                                <div v-for="(item, index) in info.ops_file" :key="index" @click="download(item.id, item.name)">
                                  <a target="_blank">{{ item.name.replace("系统用户复核附件-","") }} </a>
                                </div>
                              </div>
                              <div v-if="info.ops_remark" v-html="info.ops_remark"/>
                            </template>
                          </Step>
                          <Step title="PMO">
                            <template slot="content">
                              <div v-if="Object.keys(info.pmo_user_dict).length !== 0">{{ info.pmo_user_dict.name }}</div>
                              <Button v-if="info.status === 'PMO' && userId === info.pmo_user_dict.id" type="primary" @click="dealStep(info.id, info.status, 'pmo', '项目经理', '项目经理', 'project')">处理</Button>
                              <div v-if="Object.keys(info.pmo_file).length !== 0">
                                <div v-for="(item, index) in info.pmo_file" :key="index" @click="download(item.id, item.name)">
                                  <a target="_blank">{{ item.name.replace("系统用户复核附件-","") }}</a>
                                </div>
                              </div>
                              <div v-if="info.pmo_remark" v-html="info.pmo_remark"/>
                            </template>
                          </Step>
                          <Step title="项目经理">
                            <template slot="content">
                              <div v-if="Object.keys(info.project_user_dict).length !== 0">{{ info.project_user_dict.name }}</div>
                              <Button v-if="info.status === '项目经理' && userId === info.project_user_dict.id" type="primary" @click="dealStep(info.id, info.status, 'project', '系统管理员', '系统管理员', 'system')">处理</Button>
                              <div v-if="Object.keys(info.project_file).length !== 0">
                                <div v-for="(item, index) in info.project_file" :key="index" @click="download(item.id, item.name)">
                                  <a target="_blank">{{ item.name.replace("系统用户复核附件-","") }}</a>
                                </div>
                              </div>
                              <div v-if="info.project_remark" v-html="info.project_remark"/>
                            </template>
                          </Step>
                          <Step title="系统管理员">
                            <template slot="content">
                              <div v-if="Object.keys(info.system_user_dict).length !== 0">{{ info.system_user_dict.name }}</div>
                              <Button v-if="info.status === '系统管理员' && !reviewStatus && userId === info.system_user_dict.id" type="primary" @click="dealStep(info.id, info.status, 'system', '产品经理', '产品组', 'product')">处理</Button>
                              <div v-if="Object.keys(info.system_file).length !== 0">
                                <div v-for="(item, index) in info.system_file" :key="index" @click="download(item.id, item.name)">
                                  <a target="_blank">{{ item.name.replace("系统用户复核附件-","") }} </a>
                                </div>
                              </div>
                              <div v-if="info.system_remark" v-html="info.system_remark"/>
                            </template>
                          </Step>
                          <Step title="产品经理" v-if="productLength === 0">
                          </Step>
                          <Step title="产品经理" v-else v-for="_user in info.product_user" :key="_user.id">
                            <template slot="content">
                              <div >{{ _user.name }}</div>
                              <Button type="primary" v-if="info.product_status[_user.id] === '进行中' && userId === _user.id" @click="dealStep(info.id, info.status, 'product', '产品经理', '测试组', 'system')">处理</Button>
                              <div v-if="info.product_file.length !== 0">
                                <div v-for="(item, index) in info.product_file[_user.id]" :key="index" @click="download(item.id, item.name)">
                                  <a target="_blank">{{ item.name.replace("系统用户复核附件-","") }} </a>
                                </div>
                              </div>
                              <div v-if="info.product_remark[_user.id]" v-html="info.product_remark[_user.id]"/>
                            </template>
                          </Step>
                          <Step title="系统管理员">
                            <template slot="content">
                              <div v-if="Object.keys(info.system_user_dict).length !== 0">{{ info.system_user_dict.name }}</div>
                              <Button v-if="info.status === '系统管理员' && reviewStatus && userId === info.system_user_dict.id" type="primary" @click="dealStep(info.id, info.status, 'test', '测试', '测试组', 'test')">处理</Button>
                            </template>
                          </Step>
                          <Step title="测试">
                            <template slot="content">
                              <div v-if="Object.keys(info.test_user_dict).length !== 0">{{ info.test_user_dict.name }}</div>
                              <Button v-if="info.status === '测试' && userId === info.test_user_dict.id" type="primary" @click="dealStep(info.id, info.status, 'test', '已完成', '测试组', 'test')">处理</Button>
                              <div v-if="Object.keys(info.test_file).length !== 0">
                                <div v-for="(item, index) in info.test_file" :key="index" @click="download(item.id, item.name)">
                                  <a target="_blank">{{ item.name.replace("系统用户复核附件-","") }} </a>
                                </div>
                              </div>
                              <div v-if="info.test_remark" v-html="info.test_remark"/>
                            </template>
                          </Step>
                        </Steps>
                    </dd>
                  </dl>
                </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
    </Card>

    <Modal :title="updateInfo.status + '处理阶段'" v-model="updateModal" @on-ok="stageUpdate">
        <Form inline :label-width="120" ref="updateInfo" :model="updateInfo" class="system-user-review-detail-update">
          <Row v-if="updateInfo.status !== '产品经理' && updateInfo.status !== '测试'">
            <Col span="24">
              <FormItem label="下阶段处理人" style="width: 100%">
                <Select v-if="updateInfo.nextStatus !== '产品经理'" v-model="updateInfo[ updateInfo.userType + '_user']" placeholder="" filterable clearable transfer style="min-width: 200px">
                  <Option v-for="item in all_user_list" :key="item.key" :value="item.key">{{ item.label }}</Option>
                </Select>
                <Select v-else v-model="updateInfo[ updateInfo.userType + '_user']" multiple placeholder="" filterable clearable transfer style="min-width: 200px">
                  <Option v-for="item in all_user_list" :key="item.key" :value="item.key">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="备注" style="width: 100%">
                <vue-editor v-model="updateInfo[ updateInfo.type + '_remark']" ref="myQuillEditorBody" :editorOptions="editorOptionBody" class="system-user-review-add-content"></vue-editor>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="附件" style="width: 100%">
                 <Upload  :action="workFlowBaseUploadUrl" ref="upload"
                          :headers="uploadHeader"
                          :on-success="uploadEnclosureSuccess"
                          :on-error="uploadEnclosureError"
                          :on-format-error="uploadEnclosureFormatError"
                          :on-exceeded-size="uploadEnclosureExceededSize"
                          :show-upload-list="true"
                          :max-size="50240"
                          >
                      <Button icon="ios-cloud-upload-outline" size="small">点击上传</Button>
                    </Upload>
              </FormItem>
            </Col>
          </Row>
        </Form>
    </Modal>

  </div>
</template>

<script>
import Approves from '../components/Approves'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { VueEditor } from 'vue2-editor'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moment from 'moment'
import { detailSystemUserReview, workFlowBaseDownloadUrl, workFlowBaseUploadUrl, stageUpdate, designatedProduct } from '@/api/workflow/system_user_review'
import { GetALLUsers } from '@/api/user'
import axios from 'axios'
export default {
  name: 'SystemUserReviewDetail',
  components: {
    Approves,
    VueEditor
  },
  data () {
    return {
      info: {},
      infoError: false,
      moment: moment,
      all_user_list: [],
      current: 1,
      workFlowBaseUploadUrl: workFlowBaseUploadUrl,
      updateInfo: {
        modal: false,
        status: 'PMO'
      },
      editorOptionBody: {
        modules: {
          toolbar: []
        }
      },
      uploadHeader: {
        Authorization: 'OPS ' + this.$store.state.user.token,
        DefaultTenant: this.$store.state.user.defaultTenant,
        SelTenants: this.$store.state.user.selTenants
      },
      userId: this.$store.state.user.userId,
      reviewStatus: false,
      updateModal: false,
      productLength: 0
    }
  },
  created: function () {
    this.init()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  beforeDestroy () {
  },
  mounted: function () {
  },
  methods: {
    // 初始化
    init () {
      this.getData()
      this.getAllUsersData()
    },

    // 获取复核信息
    getData () {
      detailSystemUserReview(this.$route.query.id).then(res => {
        this.info = res.data
        this.productLength = Object.keys(this.info.product_status).length
        let finishCount = 0
        if (this.productLength !== 0) {
          let reviewStatus = true
          Object.keys(this.info.product_status).forEach(id => {
            if (this.info.product_status[id] === '进行中') {
              reviewStatus = false
            } else {
              finishCount += 1
            }
          })
          this.reviewStatus = reviewStatus
        }
        this.info.status === 'PMO' ? this.current = 1 : this.info.status === '项目经理' ? this.current = 2 : (this.info.status === '系统管理员' && this.productLength) ? this.current = 4 : this.info.status === '系统管理员' ? this.current = 3 : this.current = 4

        if (finishCount !== 0) {
          this.current += finishCount
        }
        if (this.info.status === '测试') {
          this.current += 1
        }
        if (this.info.status === '已完成') {
          this.current = 6 + this.productLength
        }
        this.infoError = false
      }).catch(res => {
        console.log(res.response, res)
        this.infoError = true
      })
    },

    // 获取所有用户列表
    getAllUsersData (group = 'PMO组') {
      this.all_user_list = []
      let params = {
        'group_name': group
      }
      GetALLUsers(params).then(res => {
        let result = res.data
        for (let i in result) {
          this.all_user_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },

    // 上传附件成功
    uploadEnclosureSuccess (res, file) {
      if (res) {
        this.updateInfo[this.updateInfo.type + '_file'].push(res)
        this.$Notice.success({
          title: '上传成功'
        })
      }
    },
    // 上传附件失败
    uploadEnclosureError (err, msg) {
      this.$Notice.error({
        title: '上传失败',
        desc: msg
      })
      console.log(err)
    },
    // 上传格式不对
    uploadEnclosureFormatError () {
      this.$Notice.error({
        title: '只能上传格式为docx/xlsx/pdf的文件'
      })
    },
    // 上传超过限制大小
    uploadEnclosureExceededSize () {
      this.$Notice.error({
        title: '限制文件大小为50M'
      })
    },

    dataURLtoBlob (encoded) {
      const dataBlob = new Blob([encoded])
      return window.URL.createObjectURL(dataBlob)
    },

    download (id, name) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          responseType: 'blob',
          url: `${workFlowBaseDownloadUrl}system_user_review/${id}/download/`,
          headers: {
            Authorization: 'OPS ' + this.$store.state.user.token,
            DefaultTenant: this.$store.state.user.defaultTenant,
            SelTenants: this.$store.state.user.selTenants
          }
        }).then((response) => {
          console.log(response)
          let downloadURL = this.dataURLtoBlob(response.data)
          let anchor = document.createElement('a')
          // 下载时显示的文件名（自定义）
          anchor.download = name
          anchor.href = downloadURL
          anchor.click()
        }).catch(err => {
          console.log({ err: err })
        })
      })
    },

    dealStep (id, status, type, nextStatus, group, userType) {
      this.updateInfo = {}
      this.updateInfo.id = id
      this.updateInfo.status = status
      this.updateInfo.type = type
      this.updateInfo.userType = userType
      this.updateInfo.nextStatus = nextStatus
      this.updateInfo[type + '_file'] = []
      this.updateInfo[type + '_remark'] = ''
      this.getAllUsersData(group)
      this.updateModal = true
    },

    stageUpdate () {
      console.log(this.updateInfo)
      const info = { }
      info.id = this.updateInfo.id
      info.type = this.updateInfo.type
      info.status = this.updateInfo.nextStatus
      if (this.updateInfo.nextStatus !== '产品经理') {
        info.user_type = this.updateInfo.userType
        info[`${info.user_type}_user`] = this.updateInfo[`${info.user_type}_user`]
      } else if (this.productLength === 0 && this.updateInfo.nextStatus === '产品经理') {
        designatedProduct({ id: this.updateInfo.id, product_user: this.updateInfo.product_user }).then(res => {
        }).catch(res => {
          if (res.request) {
            this.$Notice.error({
              title: '操作失败！',
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '操作失败！'
            })
          }
        })
      }
      if (info.type === 'product' || (info.type === 'test' && this.info.status === '测试')) {
        info[`${info.type}_user`] = this.$store.state.user.userId
        info[`${info.type}_status`] = '已完成'
      }

      info[`${info.type}_remark`] = this.updateInfo[`${info.type}_remark`]
      info[`${info.type}_file`] = this.updateInfo[`${info.type}_file`]
      stageUpdate(info).then(res => {
        this.$Notice.success({ title: '操作成功' })
        this.init()
        this.doClear()
        this.updateModal = false
      }).catch(res => {
        this.updateModal = false
        console.log(res.response, res)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },

    doClear () {
      this.$refs.upload.clearFiles()
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .system-user-review-detail-describe {
    padding: 0;
    overflow-y: auto;
    max-height: 350px;
    padding-bottom: 5px;
    margin-top: 5px;
  }
  .system-user-review-detail-describe::-webkit-scrollbar {
    width: 5px;
  }
  .system-user-review-detail-describe::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .system-user-review-detail-describe::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
  .system-user-review-detail-update{
    .ql-toolbar {
      display: none;
    }
    .ql-container {
      border-radius: 4px;
      border-top: 1px solid #ccc !important;
    }
  }
</style>
